<template>
  <div class="flex login">
    <div class="login__form">
      <h1>Logowanie</h1>
      <p> {{ loginMessage }}</p>
      <div class="login__form__inputs flex">
        <label for="user">Użytkownik:</label>
        <input id="user" type="text"
        v-model="user.userName"
        >
        <label for="pass">Hasło:</label>
        <input id="pass" type="password"
        v-model="user.userPassword"
        >
        <button class="btn"
        @click="login"
        >Zaloguj</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import auth from '@/utils/login'

export default {
  data(){
    return {
      user: {
        userName: '',
        userPassword: '',
      }
    }
  },
  mounted() {
      const token = window.localStorage.getItem('token');

      if(token !== null) {
        this.$router.push('/main')
      }
  },
  computed: {
    ...mapState(['info']),
    ...mapState({
      loginMessage: 'info'
    })
  },
  methods: {
    ...mapActions({sendMessage: 'message', logInUser: 'login'}),
    async login(){
      this.sendMessage('message', 'Logowanie...')
      const response = await auth(this.user);

      if(response.success) {
        this.logInUser(response);
        this.saveAuthData(response.token, response.role, response.user)
        this.sendMessage('Zalogowano')
      } else {
        this.sendMessage(response.message);
      }
    },
    saveAuthData(token, role, user) {
      if(token != undefined){
        window.localStorage.setItem('token',token);
        window.localStorage.setItem('role', role);
        window.localStorage.setItem('id', user);
        this.$router.push('/main')
      }
    }
  }
}
</script>